import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  Avatar,
  Badge,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CountDays from "../../common/DateTimeCalc";

function Notification() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  const listCustomerRedux = useSelector((redux) => redux.customer.listCustomer);
  const listWarning = listCustomerRedux
    .filter((customer) => {
      let countDays = CountDays(customer.last_pay_date);
      return countDays >= 7; // && customer.totalMoney > 0;
    })
    .sort(compare);
  function compare(a, b) {
    if (a.last_pay_date < b.last_pay_date) {
      return -1;
    }
    if (a.last_pay_date > b.last_pay_date) {
      return 1;
    }
    return 0;
  }

  return (
    <Stack>
      <IconButton onClick={handleClick}>
        <Badge badgeContent={listWarning.length} color="error">
          <NotificationsActiveIcon sx={{ fontSize: 40 }} color="primary" />
        </Badge>
      </IconButton>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
        {listWarning.length === 0 ? (
          <Typography variant="h5" px={1}>
            Không có thông báo mới
          </Typography>
        ) : (
          ""
        )}
        {listWarning.map((customer) => {
          return (
            <MenuItem
              key={customer.customer_id}
              onClick={() => {
                handleClose();
                navigate("/customer/" + customer.customer_id);
              }}
            >
              {/* <Avatar
                src={require("../../static/image/icon/".concat(
                  due.customerImage
                ))}
              /> */}
              <Typography variant="h5">
                {customer.customer_name +
                  " - " +
                  // customer.totalMoney +
                  // "k " +
                  CountDays(customer.last_pay_date) +
                  " Ngày"}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </Stack>
  );
}

export default Notification;
